import styled from "styled-components";
import { Modal, ModalProps } from "semantic-ui-react";

export const ModalWrapper = styled(Modal)<ModalProps>`
  height: auto;
  top: auto;
  left: auto;
  bottom: auto;
  right: auto;
`;
